/**
 * Prevent repeated clicks
 * @Example v-debounce：500="func"
 * @Example v-debounce：500="()=>func('1')"
 */


import type { App, Directive, DirectiveBinding } from 'vue';

let throttleTimer: NodeJS.Timeout | null , debounceTimer: null;

const debounceDirective: Directive = {
  mounted(el: HTMLElement, binding: DirectiveBinding) {

    const eventType: string =  Object.keys(binding.modifiers)[0] || 'click'

    el.addEventListener(eventType, () => {

      const dealy: number = binding.arg ? parseInt(binding.arg) : 300;
      const fn: unknown = binding.value;

      if (isNaN(dealy)) {
        throw Error("v-debounce:arg必须为数字!");

      }

      if (typeof fn !== "function") {

        throw Error("v-debounce绑定值必须为函数!");
      }

      if (debounceTimer) {
        return;
      }

      debounceTimer = setTimeout(() => {
        fn();
        debounceTimer = null
      }, dealy);

    });
  },
}
const throttleDirective: Directive = {
  mounted(el: HTMLElement, binding: DirectiveBinding) {

    const eventType: string = Object.keys(binding.modifiers)[0] || 'click'

    el.addEventListener(eventType, () => {

      const dealy: number = binding.arg ? parseInt(binding.arg) : 300;
      const fn: unknown = binding.value;

      if (isNaN(dealy)) {
        throw Error("v-throttle:arg必须为数字!");
      }

      if (typeof fn !== "function") {
        throw Error("v-throttle绑定值必须为函数!");
      }

      if (throttleTimer) {
        clearTimeout(throttleTimer);
      }

      throttleTimer = setTimeout(() => {
        fn();
      }, dealy);

    });
  },
}


export function setupDebounceDirective(app: App) {
  app.directive('debounce', debounceDirective);
}

export function setupThrottleDirective(app: App) {
  app.directive('throttle', throttleDirective);
}

